import React, {
    useState,
    useEffect,
    useContext,
} from 'react';
import * as Styled from './styled';
import { ThemeContext } from '@src/index';
import Flag from '@components/flag';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

const GlossyCarousel = ({ images }) => {
    const palette = useContext(ThemeContext);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const radius = 280;
    const radiusMobile = 180;
    const itemCount = images.length;
    const angleStep = 360 / itemCount;

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () =>
            window.removeEventListener(
                'resize',
                checkMobile
            );
    }, []);

    useEffect(() => {
        let interval;
        if (!isHovered && !isMobile) {
            interval = setInterval(() => {
                setCurrentIndex(
                    prev => (prev + 1) % itemCount
                );
            }, 4000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [isHovered, itemCount, isMobile, currentIndex]);

    const handlePrev = () => {
        setCurrentIndex(
            prev => (prev - 1 + itemCount) % itemCount
        );
    };

    const handleNext = () => {
        setCurrentIndex(prev => (prev + 1) % itemCount);
    };

    return (
        <Styled.CarouselContainer
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Styled.NavigationButton
                position="left"
                onClick={handlePrev}
                $CARD_BACKGROUND_COLOR={
                    palette.CARD_BACKGROUND_COLOR
                }
                $CARD_BORDER_COLOR={
                    palette.CARD_BORDER_COLOR
                }
                $PRIMARY_FONT_COLOR={
                    palette.PRIMARY_FONT_COLOR
                }
                $isDarkMode={palette.isDarkMode}
            >
                <FontAwesomeIcon icon={faChevronLeft} />
            </Styled.NavigationButton>

            <Styled.CarouselLabel
                $active={!isMobile || !isHovered}
                $CARD_BACKGROUND_COLOR={
                    palette.CARD_BACKGROUND_COLOR
                }
                $CARD_BORDER_COLOR={
                    palette.CARD_BORDER_COLOR
                }
                $PRIMARY_FONT_COLOR={
                    palette.PRIMARY_FONT_COLOR
                }
            >
                {images[currentIndex].text}
                <Flag
                    iso3={images[currentIndex].iso3}
                    size={20}
                />
            </Styled.CarouselLabel>

            <Styled.CarouselStage
                style={{
                    transform: `rotateY(${
                        -currentIndex * angleStep
                    }deg)`,
                }}
            >
                {images.map((item, index) => {
                    const rotateAngle = index * angleStep;
                    const isActive = index === currentIndex;

                    return (
                        <Styled.CarouselItem
                            key={index}
                            $rotate={rotateAngle}
                            $radius={radius}
                            $radiusMobile={radiusMobile}
                            $active={isActive}
                            $CARD_BORDER_COLOR={
                                palette.CARD_BORDER_COLOR
                            }
                            $isDarkMode={palette.isDarkMode}
                            onClick={() =>
                                setCurrentIndex(index)
                            }
                        >
                            <img
                                src={item.url}
                                alt={item.text}
                            />
                        </Styled.CarouselItem>
                    );
                })}
            </Styled.CarouselStage>

            <Styled.NavigationButton
                position="right"
                onClick={handleNext}
                $CARD_BACKGROUND_COLOR={
                    palette.CARD_BACKGROUND_COLOR
                }
                $CARD_BORDER_COLOR={
                    palette.CARD_BORDER_COLOR
                }
                $PRIMARY_FONT_COLOR={
                    palette.PRIMARY_FONT_COLOR
                }
                $isDarkMode={palette.isDarkMode}
            >
                <FontAwesomeIcon icon={faChevronRight} />
            </Styled.NavigationButton>
        </Styled.CarouselContainer>
    );
};

export default GlossyCarousel;
